import { useState, useEffect } from 'react';
import DOMPurify from 'dompurify';
import { COLORS } from '../lib/colors';
import { formatArticleDate } from '../lib/format';
import NewsletterSection from '../sections/NewsletterSection';

// Vista de un artículo, /conocimiento/{slug}. No existe en la referencia: es la
// única ruta aparte del sitio, con URL propia, compartible e indexable.
export default function ArticleDetail({ slug, onBack }) {
  const [article, setArticle] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    setLoading(true);
    fetch(`/api/articles.php?slug=${encodeURIComponent(slug)}`)
      .then(r => r.json())
      .then(data => {
        if (data.success) {
          setArticle(data.data);
        } else {
          setError("Artículo no encontrado.");
        }
      })
      .catch(() => setError("Error al cargar el artículo."))
      .finally(() => setLoading(false));
  }, [slug]);

  if (loading) return (
    <div style={{ background: COLORS.white, padding: "clamp(64px, 12vw, 160px) 0", textAlign: "center" }}>
      <p style={{ fontFamily: "'Inter', sans-serif", color: COLORS.textLight }}>Cargando...</p>
    </div>
  );

  if (error || !article) return (
    <div style={{ background: COLORS.white, padding: "clamp(64px, 12vw, 160px) clamp(20px, 8vw, 128px)", textAlign: "center" }}>
      <p style={{ fontFamily: "'Inter', sans-serif", color: COLORS.textLight, marginBottom: 24 }}>{error || "Artículo no encontrado."}</p>
      <button onClick={onBack} style={{ fontFamily: "'Inter', sans-serif", fontSize: 15, color: COLORS.copperText, background: "none", border: "none", cursor: "pointer", fontWeight: 500 }}>
        ← Volver a artículos
      </button>
    </div>
  );

  const cleanHtml = DOMPurify.sanitize(article.content, {
    ALLOWED_TAGS: ["p", "br", "strong", "em", "a", "ul", "ol", "li", "h2", "h3", "h4",
                   "blockquote", "img", "table", "thead", "tbody", "tr", "th", "td"],
    ALLOWED_ATTR: ["href", "title", "src", "alt", "target", "rel", "class", "colspan", "rowspan"],
    ALLOWED_CLASSES: { "*": ["indent-1", "indent-2", "indent-3", "indent-4",
                              "align-left", "align-center", "align-right", "align-justify"] },
  });

  return (
    <div>
      {/* El header de la referencia es fijo y mide 96px sin scroll, así que el
          padding superior lo suma: si no, "Volver a artículos" queda debajo. */}
      <section style={{ background: COLORS.navy, padding: "clamp(48px, 8vw, 80px) clamp(20px, 8vw, 128px)", paddingTop: "calc(clamp(48px, 8vw, 80px) + 96px)" }}>
        <div>
          <button onClick={onBack} style={{ fontFamily: "'Inter', sans-serif", fontSize: 14, color: COLORS.copper, background: "none", border: "none", cursor: "pointer", marginBottom: 24, padding: 0 }}>
            ← Volver a artículos
          </button>
          <p style={{ fontFamily: "'Inter', sans-serif", fontSize: 14, color: COLORS.copper, marginBottom: 12 }}>
            {formatArticleDate(article.published_at)}
          </p>
          <h1 style={{
            fontFamily: "'Playfair Display', serif",
            fontSize: "clamp(28px, 6vw, 40px)",
            fontWeight: 400,
            letterSpacing: "-0.01em",
            color: COLORS.cream,
            lineHeight: 1.2,
            margin: 0,
          }}>
            {article.title}
          </h1>
          {/* mutedLight, no textLight: esta linea vive sobre el hero oscuro.
              textLight esta calibrado para fondos claros y aqui daba 3.36:1. */}
          {article.author && (
            <p style={{ fontFamily: "'Inter', sans-serif", fontSize: 14, color: COLORS.mutedLight, marginTop: 16 }}>
              Por {article.author.display_name}
            </p>
          )}
        </div>
      </section>

      {article.featured_image && (
        <section style={{ padding: "0 clamp(20px, 8vw, 128px)", background: COLORS.white }}>
          <img src={article.featured_image} alt={article.title} style={{ width: "100%", maxHeight: 480, objectFit: "cover", marginTop: 40 }} />
        </section>
      )}

      <section style={{ padding: "48px clamp(20px, 8vw, 128px) clamp(64px, 12vw, 160px)", background: COLORS.white }}>
        <div style={{ maxWidth: 760 }}>
          <div
            className="article-content"
            dangerouslySetInnerHTML={{ __html: cleanHtml }}
            style={{
              fontFamily: "'Inter', sans-serif",
              fontSize: 17,
              color: COLORS.text,
              lineHeight: 1.9,
            }}
          />
        </div>
      </section>

      <NewsletterSection />
    </div>
  );
}
